<template>
<div class="cards">

  <div class="cards" ref="cards">
    <div class="card" v-show="visible" :style="rCS(item, iK)" :key="item.i1" v-for="(item, iK) in items">
      <img class="card-frame" src="./img/card-frame.svg" :alt="iK">
      <div class="card-name">{{ item[U].name }}</div>
      <div class="card-subtitle">{{ item[U].subtitle }}</div>
      <div class="card-desc-row">
        <div class="card-desc">{{ item[U].desc }}</div>
      </div>
    </div>
  </div>
  <img class="arrow arrow-left" src="./img/right.svg" @click="choose(-1)" alt="">
  <img class="arrow arrow-right" src="./img/left.svg" @click="choose(1)" alt="">

</div>
</template>

<script>
import * as Text from '@/components/DOM/Text/Text.js'
var TWEEN = require('@tweenjs/tween.js')

export default {
  props: {
    nK: {
    },
    items: {}
  },
  data () {
    return {
      Text,
      visible: true,
      get U () {
        return Text.state.U
      },
      adder: 0,
      delta: 0,
      x: 0,
      itemIndex: 0
    }
  },
  watch: {
    U () {
      this.visible = true
      setTimeout(() => {
        this.visible = false
        setTimeout(() => {
          this.visible = true
        }, 100)
      }, 100)
    },
    nK () {
      this.itemIndex = this.nK % this.items.length
      this.scrollIntoView(this.nK)
    }
  },
  mounted () {
    this.itemIndex = this.nK % this.items.length

    let cards = this.$refs['cards']
    let iState = {
      inertia: 1,
      sx: 0,
      sy: 0,
      dx: 0,
      dy: 0
    }

    var touchstartr = (evt) => {
      iState.sx = evt.touches[0].pageX
      iState.sy = evt.touches[0].pageY
    }
    var touchmover = (evt) => {
      iState.dx = evt.touches[0].pageX - iState.sx
      iState.dy = evt.touches[0].pageY - iState.sy
      iState.sx = evt.touches[0].pageX
      iState.sy = evt.touches[0].pageY

      iState.inertia = 1
    }

    // var wheelr = (evt) => {
    //   evt.preventDefault()

    //   iState.inertia = 1
    //   iState.dx = evt.deltaY
    //   iState.dx += -evt.deltaX * 0.5
    // }

    cards.addEventListener('touchstart', touchstartr)
    cards.addEventListener('touchmove', touchmover)
    // cards.addEventListener('wheel', wheelr)

    var rAF = () => {
      if (iState.inertia >= 0.01) {
        this.adder += iState.dx * iState.inertia
        // this.adder -= 0.75
      } else {
        // this.adder -= 0.75
      }
      iState.inertia *= 0.97
      window.requestAnimationFrame(rAF)
    }
    window.requestAnimationFrame(rAF)
  },
  methods: {
    choose (adder) {
      this.itemIndex -= adder
      this.scrollIntoView(this.itemIndex)
    },
    scrollIntoView (iK) {
      let nV = -((iK - 3) % (this.items.length)) * (304 + 40.123)

      let ov = { x: this.adder }
      var tween = new TWEEN.Tween(ov)
        .to({
          x: nV
        }, 1000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.adder = ov.x
        })

      tween.start()
    },
    rCS (item, iK) {
      let max = ((304 + 40.123) * (this.items.length))
      let v = this.adder + max * 1000
      let x = (iK * (304 + 40.123) + v) % max

      x = x - (304 + 40.123) * 3
      this.x = x
      return {
        transform: `translate3d(${x}px, 0px, 0.1px)`
      }
    }
  }
}
</script>

<style scoped>
.cards{
  position: relative;
  height: 200px;
  width: 100%;
  max-width: 1600px;
  overflow: hidden;
  mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 1.0) 15%, rgba(0, 0, 0, 1.0) 85%, transparent 100%);
}

@media screen and (min-width: 500px) {
  .cards{
    max-width: calc(374px + 50px);
    mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 1.0) 15%, rgba(0, 0, 0, 1.0) 85%, transparent 100%);
    /* mask-image: linear-gradient(90deg, transparent 80vmin, rgba(0, 0, 0, 1.0), rgba(0, 0, 0, 1.0), transparent 80vmin); */
  }
}

.card{
  height: 172px;
  width: 304px;
  position: absolute;
  top: 0px;
  left: calc(50% - 304px / 2);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-frame{
  position: absolute;
  top: 0px;
  left: 0px;
}

.card-name{
  /* margin-top: 30px; */
  /* Ho: */
  /* border: 1px solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #CEBC9E;
  letter-spacing: 2.57px;
  text-align: center;
  line-height: 20px;
}

.card-subtitle{
  white-space: pre-wrap;
  margin-top: 10px;
  /* Aged 17, Male, Cance: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 0.93px;
  text-align: center;
  line-height: 20px;
}
.card-desc-row{
  margin-top: 15px;
  display: flex;
  justify-content: center;
  font-size: 16px;
  line-height: 23px;
}
.card-desc{
  white-space: pre-wrap;
  width: 266px;
  /* I want to have a pro: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 18px;
  color: #FFFFFF;
  letter-spacing: 1px;
  text-align: center;
  line-height: 22px;
}

.arrow{
  cursor: pointer;
  position: absolute;
  top: calc(50% - 53px / 2);
}
.arrow-left{
  right: 30px;
}
.arrow-right{
  left: 30px;
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .card-frame{
    width: 306px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/KidsWishes/Cards/Cards.vue